import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import twoLogos from "../images/twoLogos.svg";
import twoLogosWhite from "../images/twoLogosWhite.svg";
import NavigationDrawer from "./NavigationDrawer";
import { useBasket } from "../context/BasketContext";

function Navigation({
    showBack = false,
    backTo = null,
    variant = "dark",
    sticky = true,
}) {
    const navigate = useNavigate();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const { getTotalItems } = useBasket();

    const isDark = variant === "dark";
    const basketCount = getTotalItems();

    const handleBack = () => {
        if (backTo) {
            navigate(backTo);
        } else {
            navigate(-1);
        }
    };

    const bgClass = isDark ? "bg-darkgray" : "bg-white";
    const textClass = isDark ? "text-white" : "text-gray-800";
    const logoSrc = isDark ? twoLogosWhite : twoLogos;

    return (
        <>
            <nav
                className={`${bgClass} ${textClass} ${
                    sticky ? "sticky top-0 z-50" : ""
                } transition-all duration-300`}
            >
                <div className="flex items-center justify-between px-4 py-3 lg:px-8 lg:py-4">
                    {/* Left: Back Button */}
                    <div className="w-24 flex justify-start">
                        {showBack && (
                            <button
                                onClick={handleBack}
                                className={`p-2 rounded-full transition-all duration-200 hover:bg-opacity-10 ${
                                    isDark ? "hover:bg-white" : "hover:bg-black"
                                }`}
                                aria-label="Go back"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-6 w-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M15 19l-7-7 7-7"
                                    />
                                </svg>
                            </button>
                        )}
                    </div>

                    {/* Center: Logo */}
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={() => navigate("/")}
                    >
                        <img
                            src={logoSrc}
                            alt="TSATSKY"
                            className="h-10 lg:h-12"
                            loading="eager"
                            decoding="async"
                        />
                    </div>

                    {/* Right: Basket + Hamburger Menu */}
                    <div className="w-24 flex items-center justify-end gap-2">
                        {/* Basket Icon */}
                        <button
                            onClick={() => navigate("/basket")}
                            className={`p-2 rounded-full transition-all duration-200 hover:bg-opacity-10 relative ${
                                isDark ? "hover:bg-white" : "hover:bg-black"
                            }`}
                            aria-label="Basket"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                                />
                            </svg>
                            {basketCount > 0 && (
                                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs w-5 h-5 flex items-center justify-center rounded-full font-medium">
                                    {basketCount > 99 ? "99+" : basketCount}
                                </span>
                            )}
                        </button>

                        {/* Hamburger Menu */}
                        <button
                            onClick={() => setIsDrawerOpen(true)}
                            className={`p-2 rounded-full transition-all duration-200 hover:bg-opacity-10 ${
                                isDark ? "hover:bg-white" : "hover:bg-black"
                            }`}
                            aria-label="Open menu"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth={2}
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            </nav>

            <NavigationDrawer
                isOpen={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
            />
        </>
    );
}

export default Navigation;
